export const filterStatusOptions = [
  { label: "Todas", value: "" },
  { label: "Aprovadas", value: "1" },
  { label: "Reprovadas", value: "2" },
  { label: "Mesa de Crédito", value: "3" },
  { label: "Efetivadas", value: "4" }
];